import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-3xl md:text-5xl font-heading font-extralight text-foreground-900 mb-3">
            {t('categories.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-52 md:h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.namePt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 text-center">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                  {cat.namePt}
                </h3>
                <p className="text-xs text-foreground-500 mb-3">
                  {cat.description}
                </p>
                <span
                  className={`inline-flex items-center justify-center w-full px-4 py-2.5 text-xs font-semibold rounded-full transition-all whitespace-nowrap ${
                    idx === 0
                      ? 'bg-primary-500 text-white hover:bg-primary-600'
                      : 'bg-background-100 text-foreground-700 border border-background-300 hover:bg-background-200'
                  }`}
                >
                  {t('categories.viewAll')}
                  <i className="ri-arrow-right-line ml-1.5 text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}